import { gameState, config } from '@js/index';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

let redf = null;
let greenf = null;

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }
  preload() {}

  create() {
    enablePointerEvents();

    this.load.image('mask', 'assets/GameUIAnims/mask.png');
    this.load.image('progressBar', 'assets/GameUIAnims/progressBar.png');
    this.load.image('holder', 'assets/GameUIAnims/holder.png');
    this.load.image('settings', 'assets/GameUIAnims/settings.png');
    this.load.image('yellow', 'assets/GameUIAnims/yellow.png');
    this.load.image('circle', 'assets/GameUIAnims/circle.png');
    this.load.image('dropDown', 'assets/GameUIAnims/dropDown.png');
    this.load.image('fullScreenOff', 'assets/GameUIAnims/fullScreenOff.png');
    this.load.image('fullScreen', 'assets/GameUIAnims/fullScreen.png');
    this.load.image('sound', 'assets/GameUIAnims/sound.png');
    this.load.image('mute', 'assets/GameUIAnims/mute.png');
    this.load.image('paused', 'assets/GameUIAnims/paused.png');

    this.load.multiatlas('playAnim', 'assets/GameUIAnims/Tera Animations/playPauseAnim.json', 'assets/GameUIAnims/Tera Animations');
    this.load.multiatlas('teraIn', 'assets/GameUIAnims/Tera Animations/teraAppearAnim.json', 'assets/GameUIAnims/Tera Animations');
    this.load.multiatlas('teraIdle', 'assets/GameUIAnims/Tera Animations/teraIdleBlinkAnim.json', 'assets/GameUIAnims/Tera Animations');
    this.load.multiatlas('teraCorrect', 'assets/GameUIAnims/Tera Animations/teraCorrectAnim.json', 'assets/GameUIAnims/Tera Animations');
    this.load.multiatlas('teraWrong', 'assets/GameUIAnims/Tera Animations/teraWrongAnim.json', 'assets/GameUIAnims/Tera Animations');
    this.load.multiatlas('teraThink', 'assets/GameUIAnims/Tera Animations/teraThinkAnim.json', 'assets/GameUIAnims/Tera Animations');
    this.load.multiatlas('teraIdea', 'assets/GameUIAnims/Tera Animations/teraIdeaAnim.json', 'assets/GameUIAnims/Tera Animations');
    this.load.multiatlas('teraOut', 'assets/GameUIAnims/Tera Animations/teraOutAnim.json', 'assets/GameUIAnims/Tera Animations');

    this.load.image('Q1', 'assets/GameSceneAssets/Q1.png');
    this.load.image('Q2', 'assets/GameSceneAssets/Q2.png');
    this.load.image('Q3', 'assets/GameSceneAssets/Q3.png');
    this.load.image('Q4', 'assets/GameSceneAssets/Q4.png');
    this.load.image('Q5', 'assets/GameSceneAssets/Q5.png');
    this.load.image('Q6', 'assets/GameSceneAssets/Q6.png');
    this.load.image('Q7', 'assets/GameSceneAssets/Q7.png');
    this.load.image('Q8', 'assets/GameSceneAssets/Q8.png');
    this.load.image('Q9', 'assets/GameSceneAssets/Q9.png');

    this.sbgMusic = this.sound.add('sbgMusic').setVolume(0.02).setLoop(true);
    config.audio.bgAudio = this.sound.add('bgMusic').setLoop(true);
    this.moveshadow = false;

    const r5 = this.add.rectangle(0, 0, 1280, 720, 0xffffff).setOrigin(0).setDepth(15).setAlpha(0);

    this.sbg = this.add.image(0, 0, 'sbg').setOrigin(0);

    this.playButton = this.add.image(536, 260, 'play_button').setInteractive({ cursor: 'pointer' }).setOrigin(0, 0);

    this.gameName = this.add.image(430, 154, 'gameName').setOrigin(0);
    this.rip = true;

    this.load.multiatlas('endConfetti', 'assets/EndSceneAssets/confetti/confettiAnimNew.json', 'assets/EndSceneAssets/confetti');

    this.load.atlas('rippleContactAnim', 'assets/anims/frogAnims/rippleContactAnim-0.png', 'assets/anims/frogAnims/rippleContactAnim.json');

    this.load.atlas('lillyPadSinkAnim', 'assets/anims/frogAnims/lillyPadSinkAnim-0.png', 'assets/anims/frogAnims/lillyPadSinkAnim.json');
    this.load.atlas('frogSinkAnim', 'assets/anims/frogAnims/frogSinkAnim-0.png', 'assets/anims/frogAnims/frogSinkAnim.json');
    this.load.atlas('bubbleBurstAnim', 'assets/anims/frogAnims/bubbleBurstAnim.png', 'assets/anims/frogAnims/bubbleBurstAnim.json');

    this.load.image('T1', 'assets/GameSceneAssets/T1.png');
    this.load.image('T2', 'assets/GameSceneAssets/T2.png');
    this.load.image('arrow1', 'assets/GameSceneAssets/arrow1.png');
    this.load.image('T3', 'assets/GameSceneAssets/T3.png');
    this.load.image('T4', 'assets/GameSceneAssets/T4.png');
    this.load.image('arrow2', 'assets/GameSceneAssets/arrow2.png');

    this.load.image('gbg', 'assets/GameSceneAssets/gbg.png');
    this.load.image('ipad', 'assets/GameSceneAssets/ipad.png');
    this.load.image('flower', 'assets/GameSceneAssets/Flower.png');

    for (let j = 0; j < 11; j++) {
      for (let i = 0; i < 4; i++) {
        this.load.image(j + '_' + i, 'assets/GameSceneAssets/' + j + '_' + i + '.png');
        this.load.image(j + '_' + i + '_c', 'assets/GameSceneAssets/' + j + '_' + i + '_c.png');
        this.load.image(j + '_' + i + '_w', 'assets/GameSceneAssets/' + j + '_' + i + '_w.png');
      }
    }

    this.load.start();

    this.loadcomplete = false;
    this.presscomplete = false;

    this.load.on(
      'complete',
      () => {
        this.loadcomplete = true;
      },
      this,
    );

    this.anims.create({
      key: 'riverripple',
      frames: this.anims.generateFrameNames('rippleHomeScreenAnim', {
        start: 0,
        end: 25,
        zeroPad: 0,
        prefix: 'rippleHomeScreen',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'fly',
      frames: this.anims.generateFrameNames('birdAnim', {
        start: 0,
        end: 369,
        zeroPad: 0,
        prefix: 'birdsAnim',
        suffix: '.png',
      }),
      repeatDelay: 2500,
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'riverflow',
      frames: this.anims.generateFrameNames('riverRockRippleAnim', {
        start: 0,
        end: 48,
        zeroPad: 0,
        prefix: 'riverRockRipple',
        suffix: '.png',
      }),
      frameRate: 15,
      repeat: -1,
    });

    this.anims.create({
      key: 'redfjump',
      frames: this.anims.generateFrameNames('redFrogJumpAnim', {
        start: 4,
        end: 21,
        zeroPad: 0,
        prefix: 'redFrogJump',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.anims.create({
      key: 'greenfjump',
      frames: this.anims.generateFrameNames('greenFrogJumpAnim', {
        start: 4,
        end: 21,
        zeroPad: 0,
        prefix: 'greenFrogJump',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.birds = this.add.sprite(0, 0, 'birdAnim').setOrigin(0);
    this.birds.play('fly');
    this.river = this.add.sprite(0, 0, 'riverRockRippleAnim').setOrigin(0);
    this.river.play('riverflow');
    this.rocks = this.add.image(415, 383, 'rocks').setOrigin(0);

    this.ripple1 = this.add.sprite(346, 572, 'riverRockRippleAnim').setOrigin(0.2);
    this.leaf1 = this.add.image(346, 572, 'sleaf').setOrigin(0);

    this.ripple2 = this.add.sprite(456, 611, 'riverRockRippleAnim').setOrigin(0.2);
    this.leaf2 = this.add.image(456, 611, 'sleaf').setOrigin(0);

    this.ripple3 = this.add.sprite(501, 565, 'riverRockRippleAnim').setOrigin(0.2);
    this.leaf3 = this.add.image(501, 565, 'sleaf').setOrigin(0);

    this.ripple4 = this.add.sprite(563, 608, 'riverRockRippleAnim').setOrigin(0.2);
    this.leaf4 = this.add.image(563, 608, 'sleaf').setOrigin(0);

    this.ripple5 = this.add.sprite(674, 585, 'riverRockRippleAnim').setOrigin(0.2);
    this.leaf5 = this.add.image(674, 585, 'sleaf').setOrigin(0);

    this.ripple6 = this.add.sprite(736, 550, 'riverRockRippleAnim').setOrigin(0.2);
    this.leaf6 = this.add.image(736, 550, 'sleaf').setOrigin(0);

    this.ripple7 = this.add.sprite(788, 608, 'riverRockRippleAnim').setOrigin(0.2);
    this.leaf7 = this.add.image(788, 608, 'sleaf').setOrigin(0);

    this.leafs = [this.leaf1, this.leaf2, this.leaf3, this.leaf4, this.leaf5, this.leaf6, this.leaf7];
    this.leafsX = [346, 456, 501, 563, 674, 736, 788];

    this.ripples = [this.ripple1, this.ripple2, this.ripple3, this.ripple4, this.ripple5, this.ripple6, this.ripple7];

    for (let i = 0; i <= 6; i++) {
      this.tweens.add({
        targets: [this.leafs[i], this.ripples[i]],
        ease: 'Linear',
        duration: 1000,
        delay: 200 + i * 500,
        x: {
          getStart: () => this.leafsX[i],
          getEnd: () => {
            if (i % 2 == 0) {
              return this.leafs[i].x + 5;
            } else {
              return this.leafs[i].x - 5;
            }
          },
        },
        yoyo: true,
        loop: -1,
      });
    }

    this.playButton.on('pointerover', () => {
      this.playButton.setTexture('play_button_on');
    });

    this.playButton.on('pointerout', () => {
      this.playButton.setTexture('play_button');
    });

    this.playButton.on('pointerdown', () => {
      this.frogjumps();
      this.sbgMusic.play();

      config.audio.bgAudio.setVolume(0.2).play();

      this.gameName.setScale(0);
      this.playButton.setScale(0);

      this.tweens.add({
        targets: r5,
        alpha: 1,
        duration: 500,
        delay: 3000,
        ease: 'Sine.easeInOut',
      });

      this.time.delayedCall(3500, () => {
        this.presscomplete = true;
        this.sbgMusic.stop();
      });
    });
  }

  frogjumps() {
    this.moveshadow = true;

    const path1 = new Phaser.Curves.Path(-90, 552).splineTo([-10, 472, 70, 552]);
    const path2 = new Phaser.Curves.Path(70, 552).splineTo([150, 472, 230, 552]);
    const path3 = new Phaser.Curves.Path(917 + 500, 552).splineTo([917 + 375, 472, 917 + 250, 552]);
    const path4 = new Phaser.Curves.Path(917 + 250, 552).splineTo([917 + 125, 472, 917, 552]);

    this.shadow1 = this.add
      .image(230 - 30, 600, 'shadow')
      .setOrigin(0)
      .setScale(0.5);

    this.shadow2 = this.add
      .image(917 - 30, 600, 'shadow')
      .setOrigin(0)
      .setScale(0.5);

    redf = this.add
      .follower(path1, -90, 552, 'redFrogJumpAnim')
      .setOrigin((89 * 1.5) / 1280, 336 / 720)
      .setScale(0.5);

    greenf = this.add
      .follower(path3, 917 + 500, 552, 'greenFrogJumpAnim')
      .setOrigin((1066 + 80) / 1280, 336 / 720)
      .setScale(0.5);

    greenf.startFollow({
      positionOnPath: true,
      duration: 600,
      yoyo: false,
      repeat: 0,
      rotateToPath: false,
      verticalAdjust: false,
      onStart: () => {
        greenf.play('greenfjump');

        this.tweens.add({
          targets: this.shadow2,
          scale: 0.4,
          duration: 300,
          yoyo: true,
          ease: 'Linear',
        });
      },
    });

    this.time.delayedCall(900, () => {
      greenf.setPath(path4);
    });

    this.time.delayedCall(500, () => {
      redf.startFollow({
        positionOnPath: true,
        duration: 600,
        yoyo: false,
        repeat: 0,
        rotateToPath: false,
        verticalAdjust: false,
        onStart: () => {
          redf.play('redfjump');

          this.tweens.add({
            targets: this.shadow1,
            scale: 0.4,
            duration: 300,
            yoyo: true,
            ease: 'Linear',
          });
        },
        onComplete: () => {},
      });

      this.time.delayedCall(900, () => {
        redf.setPath(path2);
      });
    });
  }

  startloads() {}

  update() {
    if (this.presscomplete && this.loadcomplete) {
      disablePointerEvents();
      this.scene.start('GameScene');
      this.scene.stop('StartScene');
      this.presscomplete = false;
    }

    if (this.moveshadow) {
      this.shadow1.x = redf.x - 30;
      this.shadow2.x = greenf.x - 30;
    }

    if (this.rip) {
      this.rip = false;

      const value = Phaser.Math.Between(0, 6);

      this.ripples[value].play('riverripple');

      this.time.delayedCall(300, () => {
        this.rip = true;
      });
    }
  }
}
